import PIcon from "../../../assets/P.svg";
import UpperHandIcons from "../../../assets/upper-hand.svg";

type SourceProps = {
  source?: string;
};

function Source({ source }: SourceProps) {
  if (!source) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      {source === "playbook365" && (
        <img src={PIcon} alt="P" className="h-5 w-auto" />
      )}
      {source === "upper-hand" && (
        <img src={UpperHandIcons} alt="Upper Hand" className="h-5 w-auto" />
      )}
    </div>
  );
}

export { Source };
